import { createFileRoute } from "@tanstack/react-router";

import SubUsersPage from "./-components/SubUsersPage";

export const Route = createFileRoute("/_app/_dashboard/subuser/")({
  component: SubUsersPage,
});
